import { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoginPage } from '../../pages/login'
import {
  useRedirectToLogin,
  useShowMaintenanceModal,
  useCheckAuth,
} from '../../features/users'
import { useClientUpdateNotification } from '../../features/notifications'
import { ThemeProvider } from '@mui/material/styles'
import { ToastProvider } from '../../contexts/ToastContext'
import AnnotatorIndexPage from './pages/index'
import AnnotatorLatestApp from './latest/App'
import { isLegacyUi } from '../medilab/useLegacyUi'
import { useGetTheme } from '../../shared'
import { portalRoutes } from '../../pages/portal/routes'
import { guideRoutes } from '../../pages/guide/routes'

const AnnotatorApp: FC = () => {
  useRedirectToLogin()
  useCheckAuth()
  const theme = useGetTheme()
  const MaintenanceModal = useShowMaintenanceModal()
  const { renderNotification } = useClientUpdateNotification()

  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          {MaintenanceModal}
          {renderNotification()}
          <Routes>
            {/* apps/medilab/App.tsx と同じ形で use_legacy_ui だけを見る。
                既存のアノテーション器（番号打ち・AI書き起こし・結果確認）は legacy 側に
                そのまま残す（松田 9/2「既存は残す」）。latest 側は閲覧専用。 */}
            <Route
              path="/"
              element={
                isLegacyUi() ? <AnnotatorIndexPage /> : <AnnotatorLatestApp />
              }
            />
            <Route path="/login" element={<LoginPage />} />
            {/* Annotator系ではポータルとガイドのみ利用可能
                （ポータルの「困ったときガイド」ボタンの遷移先） */}
            {portalRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {guideRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </ToastProvider>
      </ThemeProvider>
    </>
  )
}

export default AnnotatorApp
